import Vue from 'vue'
import goalEdit from './goaledit.js'
import { goalbookUrls } from '@/links'

const customAnchorState = {
  namespaced: true,
  state: {
    anchorPageUuid: null,
    primaryGoalText: null,
    objectives: [], // [{level, text, title}, ...]
    goalTranslationLanguages: []
  },
  mutations: {
    setAnchorPageUuid(state, uuid) {
      state.anchorPageUuid = uuid
    },
    setPrimaryGoalText(state, payload) {
      state.primaryGoalText = payload.text
    },

    /* payload should have two ir tgree attributes: index and objective Object{level, text, title}, and optionally initial: bool */
    setObjective(state, payload) {
      Vue.set(state.objectives, payload.index, {
        level: payload.objective.level,
        text: payload.objective.text,
        title: payload.objective.title
      })
    },

    clearObjectives(state) {
      state.objectives = []
    },

    setGoalTranslationLanguages(state, languages) {
      state.goalTranslationLanguages = languages
    }
  },
  actions: {
    // should be called when the goal content page being worked with is changed/updated (i.e. viewing a new goal content page)
    initializeCustomAnchorPage(context, { contentUuid, primaryGoalText, objectivesArray }) {
      context.commit('setAnchorPageUuid', contentUuid)
      context.commit('setPrimaryGoalText', { text: primaryGoalText })
      objectivesArray &&
        objectivesArray.forEach((objective, index) => {
          context.commit('setObjective', {
            index,
            objective: { level: objective.level, text: objective.text, title: objective.title }
          }) // make a copy of the objective
        })
      if (!objectivesArray || objectivesArray.length === 0) {
        context.commit('clearObjectives')
      }
    },
    fetchGoalTranslationLanguages(context) {
      return fetch(`${goalbookUrls.pathwaysApi}/translation_generation/languages`, {
        method: 'GET',
        credentials: 'include'
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.json()
      })
      .then(languages => {
        context.commit('setGoalTranslationLanguages', languages)
      })
      .catch(error => {
        console.error('Unable to fetch translation languages', error)
        context.commit('setGoalTranslationLanguages', [{
          language_name: 'English',
          released: true,
          right_to_left: false,
          beta_only: false
        }])
      })
    }
  },
  getters: {
    // payload doesn't include student info; caller needs to provide info
    savedAnchorPayload(state, getters, rootState, rootGetters) {
      let payload = {
        goal_uuid: state.anchorPageUuid,
        user_uuid: rootState.user.user.uuid,
        grade_level_goal: state.primaryGoalText,
        objectives: state.objectives
      }

      return payload
    },
    goalTranslationLanguages(state) {
      return state.goalTranslationLanguages.filter(lang => lang.released).map(lang => lang.language_name)
    },
    betaGoalTranslationLanguages(state) {
      return state.goalTranslationLanguages.filter(lang => lang.beta_only).map(lang => lang.language_name)
    },
    goalTranslationLanguagesRtoL(state) {
      return state.goalTranslationLanguages.reduce((acc, lang) => {
        if (lang.right_to_left) {
          acc.push(lang.language_name)
        }
        return acc
      }, [])
    }
  }
}

customAnchorState.state = Object.assign(goalEdit.state, customAnchorState.state)
customAnchorState.mutations = Object.assign(goalEdit.mutations, customAnchorState.mutations)

export default customAnchorState
